import { render } from "./OrderPreview.vue?vue&type=template&id=0e981054&scoped=true"
import script from "./OrderPreview.vue?vue&type=script&lang=ts"
export * from "./OrderPreview.vue?vue&type=script&lang=ts"

import "./OrderPreview.vue?vue&type=style&index=0&id=0e981054&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e981054"

export default script